// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type MPFamilyId } from '../types/families';

const emptyArray: [] = [];

const getFamilyIdFromProps = (_: StateType, { familyId }: { familyId: MPFamilyId }) => familyId;

export const selectMPFamilies = createSelector(
  (state: StateType) => state?.mp?.families ?? emptyArray,
  (families) => families,
);

export const selectMPFamiliesOrder = createSelector(
  (state: StateType) => state?.mp?.familyOrder ?? emptyArray,
  (familyOrder) => familyOrder,
);

export const selectMPFamilyInfo = createSelector(
  [selectMPFamilies, getFamilyIdFromProps],
  (families, familyId) => families[familyId],
);
